module.exports = __webpack_public_path__ + "media/images/home/cover-img-29a83d92d71fed4d5b0cbbead34e610a.jpg";